/**
 * web-vitals 6 uses Array.at inside deferred PerformanceObserver callbacks
 * (including its non-attribution build). Import rejection handling cannot
 * catch those later failures. Do not run this optional instrumentation where
 * the required API is absent; the app itself remains fully available.
 */
export function loadCompatibleWebVitals(arrayAt: unknown = Array.prototype.at) {
  if (typeof arrayAt !== "function") return Promise.resolve(null);
  return import("web-vitals/attribution");
}